module.exports = __webpack_public_path__ + "static/img/283_TO8_2429.e1fe5cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/283_TO8_2429.jpg
// module id = /L4R
// module chunks = 0